<template>
    <div class="d-flex flex-column-reverse pa-md-4 pa-2 align-end" :style="{ position: 'fixed', bottom: bottomStyle,top:topStyle, right:0,overflow:'auto', zIndex:zIndex,width: '500px', maxWidth: '100vw'}">
        <Alert class="flex-1" v-for="(alert, index) in alerts" :tempo-alertas-variados="tempo_alertas_variados" :tempo-alertas-erro="tempo_alertas_erro" :first-index-not-paused="firstIndexNotPaused" :key="index" :index="index" :alert="alert" @close="removeAlert(index)" @pause="pauseAlert" />
    </div>
</template>

  <script>
  import { mapState } from 'vuex'
  import Alert from '../Alert.vue'

  export default {
    components: {
      Alert
    },
    props: {
      alerts: Array
    },
    computed: {
      ...mapState(['tempo_alertas_variados', 'tempo_alertas_erro']),
      zIndex () {
        return 9999998
      },
      bottomStyle () {
        return this.$vuetify.breakpoint.smAndDown ? 'auto' : '0'
      },
      topStyle () {
        return this.$vuetify.breakpoint.smAndDown ? '50px' : 'auto'
      },
      firstIndexNotPaused () {
        return this.alerts.findIndex(alert => !(alert && alert.pause))
      }
    },
    methods: {
      removeAlert (index) {
        this.$emit('remove', index)
      },
      pauseAlert (index) {
        this.$emit('pause', index)
      }
    }
  }
  </script>
